import DynamicFieldsHandler from "~/models/dynamicFields/handlers/dynamicFieldsHandler";
import {
  ObjectModelRecordMetadataOption,
  ObjectModelRecordMetadataOptions
} from "~/models/dynamicFields/options/objectModelRecordMetadataOptions";
import {
  IDynamicDataConfig,
  IDynamicDataSectionConfig,
  IDynamicReferencedThing
} from "~/interfaces/dynamicFieldsInterfaces";
import {DynamicReferenceType} from "~/enums/dynamicReferenceType";
import Formula from "~/models/formula";
import ObjectModel from "~/models/objectModel";
import ObjectModelPropertyOptions from "~/models/dynamicFields/options/objectModelPropertyOptions";
interface IObjectModelPropertyFieldsHandlerConfig {
  objectModel?: ObjectModel,
  pillColor?: string,
  elementOptions?: ObjectModelPropertyOptions
  meta?: (selectedItem) => string
}
export default class ObjectModelRecordMetadataDynamicFieldsHandler extends DynamicFieldsHandler {
  SECTIONS = ['objectModelRecordMetadata'];
  dynamicMessage: string;
  showDynamicMessage: boolean;
  pillColor: string = 'light-grey';
  meta: (selectedItem) => string

  elementOptions = new ObjectModelRecordMetadataOptions();

  constructor(options?: IObjectModelPropertyFieldsHandlerConfig) {
    super(options);
    this.pillColor = options?.pillColor;
  }


  getOptions(q: string): Array<ObjectModelRecordMetadataOption> {
    return this.elementOptions.matchElements(null, q);
  }

  hasMetadataMatch(q: string): boolean {
    return this.getOptions(q).length > 0;
  }

  select(option: ObjectModelRecordMetadataOption): IDynamicDataConfig {
    return super.select(option, {
      type: DynamicReferenceType.ObjectModelRecordMetadata,
      id:  Formula.buildDynamicId({id: option.type.toString(),  dynamicReferenceType: DynamicReferenceType.ObjectModelRecordMetadata}),
      pillColor: this.pillColor,
      label: option.name,
    })
  }

}
